// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { OfflineTrafficSeries } from '@coa/app/shared/stores-shared/models/offline-traffic-series';

export const offlineTrafficRequested = createAction('[OFFLINE TRAFFIC] Offline traffic Requested', props<{
  timePeriod: DateRangeFilter,
  clientId: string,
  categoryId?: string
}>());
export const offlineTrafficRequestSucceeded = createAction('[OFFLINE TRAFFIC] Offline traffic Request Succeeded', props<{
  offlineTraffic: OfflineTrafficSeries[]
}>());
export const offlineTrafficRequestFailed = createAction('[OFFLINE TRAFFIC] Offline traffic Request Failed');
